/*# sourceMappingURL=translation-table-cell.component-MB6JQ4NT.css.map */
